// extracted by mini-css-extract-plugin
export var footerLegalContainer = "styles-module--footerLegalContainer--1f3d2";
export var termsContainer = "styles-module--termsContainer--8c1c6";